import { useMutation } from "@tanstack/react-query";
import {
  mvpApiSearchEmbeddings,
  MvpApiSearchEmbeddingsResponse,
  EmbeddingSearchSchema,
} from "@labeling-tools/api/embeddington";

/**
 * React Query hook to search embeddings using the Embeddington API
 */
export function useSearchEmbeddings() {
  return useMutation({
    mutationFn: async (
      payload: EmbeddingSearchSchema,
    ): Promise<MvpApiSearchEmbeddingsResponse> => {
      const response = await mvpApiSearchEmbeddings({
        body: payload,
      });

      if (response.error) {
        throw new Error(`Failed to search embeddings: ${response.error}`);
      }

      return response.data as MvpApiSearchEmbeddingsResponse;
    },
    onSuccess: (data) => {
      return data;
    },
    onError: (error) => {
      console.error("Search embeddings failed:", error);
    },
  });
}
